import * as tg from "generic-type-guard";

export const isDocumentWithFachverfahrenData = new tg.IsInterface()
	.withProperties({
		root: new tg.IsInterface()
			.withOptionalProperties({
				antrag: new tg.IsInterface()
					.withOptionalProperties({
						DatenImport: tg.isObject,
						einlesenInformationen: tg.isObject,
						antragsdatum: tg.isUnion(tg.isString, tg.isInstance(Date))
					})
					.get()
			})
			.withProperties({
				genehmigungsverfahren: tg.isObject
			})
			.get()
	})
	.get();

export type DocumentWithFachverfahrenData = tg.GuardedType<typeof isDocumentWithFachverfahrenData>;

export const isDocumentWithProcessState = new tg.IsInterface()
	.withProperties({
		root: new tg.IsInterface()
			.withProperties({
				processMetadata: new tg.IsInterface()
					.withProperties({
						task: new tg.IsInterface()
							.withProperties({
								key: tg.isString
							})
							.get()
					})
					.get()
			})
			.get()
	})
	.get();
